import { BOLT_TYPES } from "@/data/boltData";

export const fmtNum = (n, d = 2) => {
  if (n == null || !isFinite(n)) return "0";
  return Number(n).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: 0 });
};

export const fmtInt = (n) => {
  if (n == null || !isFinite(n)) return "0";
  return Math.round(n).toLocaleString("en-IN");
};

// bags shown as "exact ≈ rounded-up", e.g. "5.2 ≈ 6"
export const fmtBags = (exact) => {
  if (!exact || !isFinite(exact) || exact <= 0) return "0 ≈ 0";
  return `${Number(exact).toFixed(1)} ≈ ${Math.ceil(exact - 1e-9)}`;
};

export const fmtDia = (system, d) => {
  if (!d) return "";
  return system === "metric" ? d : `${d}"`;
};

export const fmtLen = (system, l) => {
  if (!l) return "";
  return system === "metric" ? `${l} mm` : `${l}"`;
};

export const fmtNutSize = (specId, size) => {
  if (!size) return "";
  return specId === "bsw" ? `${size}"` : size;
};

export const boltTypeName = (typeId) => BOLT_TYPES.find((b) => b.id === typeId)?.name || "";

export const boltShortLabel = (sel) =>
  `${fmtDia(sel.system, sel.dia)} × ${fmtLen(sel.system, sel.len)}`;

export const boltFullLabel = (sel) =>
  `${boltShortLabel(sel)} · ${boltTypeName(sel.typeId)}`;
